<template>
	<div class="ma-0 pa-0">
	
		<v-dialog v-model="saveDialog" width="72%" elevation="8" fade>
			<v-card :color="feedback_type">
				<div :class="`headline text-center py-4`">{{ feedback_msg }}</div>
			</v-card>
		</v-dialog>
	
		<ConfirmDialog
			v-if="confirmDialog"
			v-model="sections"
			:moduleKey="moduleKey"
			@cancel="confirmDialog=false"
			@confirm="saveValues(true)"
			@navigate="navigateToSection"
		/>
	
		<v-dialog
			v-model="helpDialog"
			width="60%"
		>
			<v-card>
				<v-card-title class="headline primary darken-3 white--text py-4 mx-0 text-center">
					<div class="" style="width: 100%">The First Step In Maximizing Your Value</div>
				</v-card-title>
	
				<v-card-text>
					<div class="my-3">
						<h3>What to expect during the questionnaire:</h3>
						<p class="my-3">
							<ol>
								<li>8 sections
									<p>There are 8 sections to complete, you may need to complete additional documents depending on your practice. We will let you know if we believe we will need additional documents.</p>
								</li>
								<li>Estimated Completion
									<p>This one really depends. If this isn&apos;t your first rodeo, you should be able to complete the questionnaire within two hours. However, getting documents and reports can take some time to achieve. We&apos;ll touch on this again in section 6.</p>
								</li>
								<li>We&apos;re Here For You!
									<p>We understand that getting a valuation is time consuming and not something you always want to be doing. We make it as easy as possible to understand your value and help you every step of the way.</p>
								</li>
							</ol>
						</p>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
		<!-- <v-dialog
			v-model="techSupportDialog"
			width="60%"
		>
			<v-card>
				<v-card-title class="headline primary darken-2 white--text py-4 mx-0 text-center">
					<div class="d-block">Some people have reported not being able to load the questionnaire ...</div>
				</v-card-title>
	
				<v-card-text>
					<div class="d-block my-4">If you are experiencing this too, please "hard refresh" your browser by clicking the button below.</div>
					<div class="d-block mt-6 mb-4 text-center">
						<HardRefresh buttonText="Refresh Questionnaire" />
					</div>
				</v-card-text>
			</v-card>
		</v-dialog> -->
	
		<div id="questionnaire" :class="questionnaire_visible">
			<template>
				<v-layout column :style="isAdmin ? `` : `background-color: #EFEFEF`">
					<div class="d-flex d-block">
						<!-- <v-btn
							icon
							small
							color="primary"
							class="d-inline"
							@click="helpDialog = true">
							<v-icon>mdi-lifebuoy</v-icon>
						</v-btn> -->
						<v-spacer></v-spacer>
						<div v-if="isAutoSaving" class="d-flex d-inline mr-3 px-3 align-center">
							<span class="general_grey--text align-center">{{ savingText }}</span>
							<v-progress-circular indeterminate color="general_grey" class="ml-2 align-center" size="24" width="2"></v-progress-circular>
						</div>
						<v-icon small color="primary" class="mx-2">mdi-lock</v-icon>
						<v-btn
							v-if="!isPartner"
							color="primary"
							@click="isAdmin ? adminQuestionniareSave() : handleSubmitReview()"
							class="d-inline px-3 white--text elevation-2"
							:disabled="isAdmin ? isAutoSaving : checkReadOnly || sugar">
							<span v-if="moduleKey != 'buyer'">{{ saveButtonText }}</span>
							<span v-else>Update Profile</span>
						</v-btn>
					</div>
					<div class="d-flex d-block align-center my-1 caption font-weight-thin general_grey--text">
						<div class="d-inline ml-1">
							{{ completedSections.length }} of {{ visibleTabs.length }} sections completed.
						</div>
						<!--<div class="warning--text ml-4" style="cursor: pointer" @click="techSupportDialog = true">
							Questionnaire not loading?
						</div> -->
						<v-spacer></v-spacer>
						<div class="d-inline">
							<div v-if="last_saved">Last Saved: {{ last_saved }}</div>
							<div v-else>&nbsp;</div>
						</div>
					</div>
				</v-layout>
			</template>
	
			<div :class="isAdmin ? '' : 'elevation-4'">
				<div class="py-3" style="background-color: #FFF"> <!-- style="background-color: #37383C"  |  dark  background-color="#37383C" -->
					<v-tabs
						v-model="currentSectionValue"
						:grow="grow"
						background-color="#FFF"
						color="grow"
						class="sansation"
						center-active
						@change="handleTabChange"
					>
						<v-tab
							v-for="(tab, idx) in visibleTabs"
							:key="tab.value"
							:href="`#${tab.value}`"
							class="px-4 grow--text"
							active-class='act_tb'
							active="true"
							:style="(idx+1) < tabs.length ? 'border-right:1px solid #ddd' : ''"
						>
							{{ tab.title }}
							<v-icon  
								class="ml-2" 
								:class="!(tab.section.unfinished && tab.section.unfinished.length > 0) ? isAdmin ? 'q_secondary--text text-lighten-1' : 'secondary--text text-lighten-1' : 'grey--text text--lighten-4'">
								mdi-checkbox-marked
							</v-icon>
						</v-tab>
					</v-tabs>
				</div>
	
				<v-progress-linear
					:active="progress_active"
					background-opacity="0.3"
					buffer-value="100"
					height="8"
					striped
					stream
					:value="completedSectionsPercent"
					:color="isAdmin ? 'q_secondary lighten-1' : 'secondary lighten-1'"
					class="d-block"
					style="border-right: 1px solid #E9F5D0">
				</v-progress-linear>
	
				<v-card v-if="!Object.keys(questionnaire_data).length" class="text-center py-12 elevation-0">
					<v-progress-circular 
						indeterminate 
						color="primary" 
						:class="show_extraWaiting ? 'mt-12' : 'my-12'" 
						size="84" 
						width="5">
					</v-progress-circular>
					<div v-if="show_extraWaiting" class="text-center waiting_text mt-6 mb-0">
						... this one is taking a little longer to load, hang in there ...
					</div>
				</v-card>

				<QuestionnaireTemplate 
					v-if="questionnaireDataLength"
					v-model="questionnaire_values"
					:moduleKey="moduleKey"
					:projectId="projectId"
					:userId="userId"
					:questionnaireData="questionnaire_data"
					:readonly="checkReadOnly"
					:validatingSubmission="validatingSubmission"
					:handleTabChange="handleTabChange"
					:openQuestionnaire="openQuestionnaire" />

				<v-tabs
					grow
					hide-slider
					class="sansation bottom_border"
				>
					<v-tab
						v-for="(di) in nav_tabs"
						:key="di.value"
						:href="`#${di.value}`"
						@click="['UPDATE PROFILE', saveButtonText].includes(di.title) ? isAdmin ? adminQuestionniareSave() : handleSubmitReview() : handleTabChange(di.value)">
	
						<v-icon v-if="di.title == 'PREV SECTION'" class="mr-1" color="primary">mdi-chevron-left</v-icon>
						<span v-if="di.title != ''" :class="`font-weight-bold ${di.color}`" style="letter-spacing: .175rem">{{ di.title }}</span>
						<v-icon v-if="di.title == 'NEXT SECTION'" class="ml-1" color="primary">mdi-chevron-right</v-icon>
					</v-tab>
				</v-tabs>
			</div>
		</div>
	</div>
	</template>
	
	<script>
	import axios from 'axios'
	import Cookie from 'js-cookie'
	import { debounce } from 'debounce'
	import appUrls from '../../helpers/environment'
	import Store from '../store'
	import questionnaireStore from '../questionnaire-store'
	import { checkVisibility } from '../utilities'
	
	import QuestionnaireTemplate from './questionnaire-template'
	import ConfirmDialog from './confirm-dialog'
	import { GROW_TABS } from '../constants'
	// import HardRefresh from '../shared/hardRefresh'
	
	const isEquivalent = (a, b) => {
		// Create arrays of property names
		var aProps = Object.getOwnPropertyNames(a);
		var bProps = Object.getOwnPropertyNames(b);
	
		// If number of properties is different,
		// objects are not equivalent
		if (aProps.length != bProps.length) {
			return false;
		}
	
		for (var i = 0; i < aProps.length; i++) {
			var propName = aProps[i];
	
			// If values of same property are not equal,
			// objects are not equivalent
			if (a[propName] !== b[propName]) {
				return false;
			}
	
			// If values of same property are not equal,
			// objects are not equivalent
			if (typeof a[propName] === 'object' && typeof b[propName] === 'object') {
				if(!isEquivalent(a[propName], b[propName])) {
					return false;
				}
			}
		}
	
		// If we made it this far, objects
		// are considered equivalent
		return true;
	}
	
export default {
	name: 'Questionnaire',
	
	components: {
		QuestionnaireTemplate,
		ConfirmDialog,
		// HardRefresh
	},
	
	 props: {
		moduleId: String,
		userId: String,
		moduleKey: String,
		projectId: String,
		// introActive: Boolean,
		readonly: Boolean,
		getCurrentProject: Function,
		openQuestionnaire: Function,
		parentProjectId: String,
		resolutionData: Object
	},
	
	data () {
		return {
			rowHeight: 24,
			rows: 1,
			sections: {},
			tabs: [],
			nav_tabs: [],
			model: null,
			last_saved: '',
			// intro_visible: 'd-none', // this.introActive ? 'd-block' : 'd-none',
			questionnaire_visible: 'd-block', // this.introActive ? 'd-none' : 'd-block',
			enitityFormationDate: String,
			progress_active: true,

			helpDialog: false,

			isAdmin: false,
			isAutoSaving: false,

			confirmDialog: false,
			saveDialog: false,
			feedback_type: '',
			feedback_msg: '',
			validatingSubmission: false,

			questionnaire_xhr: {},
			questionnaire_data_cache: {},
			questionnaire_data: {},
			questionnaire_values: {},
			currentSection: null,
			completedSections: [],
			completedSectionsPercent: 0,
			intialLoad: true,
			show_extraWaiting: false,

			isPartner:false,
			questionnaireUserGroupIDs: {},

			techSupportDialog: false
		}
	},
	
	computed: {
		checkReadOnly() {
			const specialSections = [
				{
					module: 'merger-premium',
					section: 'nm-ensemble-info',
					roles: [1,2,3,6,8]
				},
				{
					module: 'merger-elite',
					section: 'nm-ensemble-info',
					roles: [1,2,3,6,8]
				},
				{
					module: 'entity-support-starter',
					section: 'nm-ensemble-info',
					roles: [1,2,3,6,8]
				},
				{
					module: 'entity-support-premium',
					section: 'nm-ensemble-info',
					roles: [1,2,3,6,8]
				},
				{
					module: 'entity-support-elite',
					section: 'nm-ensemble-info',
					roles: [1,2,3,6,8]
				}
			];
			const thisQuesionnaireName = this.questionnaire_data && this.questionnaire_data.name;
			this.questionnaireUserGroupIDs = questionnaireStore.userInfo && questionnaireStore.userInfo.group_ids || {};

			// Short circuit if not readonly
			if (!this.readonly) return false;

			// Check if current section allows additional checks
			const currentSection = specialSections.find(
				s => s.module === this.moduleKey && s.section === (thisQuesionnaireName)
			);

			// Not a special section
			if (!currentSection) return true;

			// Check if user has special roles for this section
			const userGroupIds = this.questionnaireUserGroupIDs.map(Number) || [];
			const hasSpecialRole = currentSection.roles.some(role => userGroupIds.includes(role));

			return !hasSpecialRole;
		},

		sugar: function () {
			return Cookie.get('sugar') == 'true' ? true : false
		},

		// Filtered tabs to only show visible tabs
		visibleTabs: function () {
			return this.tabs.filter((tab) => tab.section && tab.section.visible);
		},

		currentSectionValue: {
			get: function () {
				// console.log(this.currentSection)
				return this.currentSection && this.currentSection.value;
			},
			set: function () {
				// Don't do nothing
			}
		},

		questionnaireDataLength: {
			get: function () {
				return Object.keys(this.questionnaire_data).length
			},
			set: function () {
				// Don't do nothing
			}
		},

		sendEmailOnSubmit: function () {
			return this.moduleKey != 'buyer' && this.moduleKey == 'merger-party-data' ? false : true
		},
	
		grow: function () {
			return this.visibleTabs.length > GROW_TABS ? true : false
		},
	
		savingText: function () {
			return this.isAdmin ? 'SAVING' : 'AUTOSAVING'
		},
	
		saveButtonText: function () {
			return this.isAdmin ? 'SAVE DATA' : this.moduleKey === 'entity-maintenance-program-resolutions' ? 'SUBMIT' : 'SUBMIT FOR REVIEW'
		}
	},
	
	watch: {
    $route(to, from) {
        this.getModuleIntro()
        this.gatherData()
        this.getQuestionnaireMenu()
        Object.keys(this.sections).forEach(this.setUnfinishedQuestions)
    },
		questionnaire_values: {
			handler (obj_values) {
				if ( this.intialLoad ) {
					this.intialLoad = false
				} else if (!this.checkReadOnly) {
					const { complete, ...watch_obj_values } = obj_values
					if (Object.keys(watch_obj_values).length > 1) {
						if ( !this.isAdmin ) {
							// Why a promise?  This handler runs before component visibility is determined leading to an edge case where validation can be incorrect.
							// Staging with a promise pushes the validation to the end of the stack allowing visibility and other properties to be set first.
							Promise.resolve().then(() => {
								if (this.currentSection) {
									this.setUnfinishedQuestions(this.currentSectionValue)
								}
							})

							// Initial the autosave
							this.debouncedAutoSave()
						}
					}
				}
	
				// Why a promise?  This handler runs before component visibility is determined leading to an edge case where validation can be incorrect.
				// Staging with a promise pushes the validation to the end of the stack allowing visibility and other properties to be set first.
				// if ( !this.isAdmin ) { 
				// 	Promise.resolve().then(() => {
				// 		if (this.currentSection) {
				// 			this.setUnfinishedQuestions(this.currentSectionValue)
				// 		}
				// 	})
				// }
			},
			deep: true
		},

		questionnaire_data: {
			handler ( obj ) {
				if ( Object.keys(obj).length ) {
					this.show_extraWaiting = false
					this.questionnaireDataLength = Object.keys(obj).length
				}
			},
			deep: true
		},
		
		visibleTabs: function () {
			// Repopulate the nav tabs when visible tabs change
			this.getDirectionalNavData();
		},
	},
	
	methods: {
		debouncedAutoSave: debounce(function () {
			this.autoSaveValues()
		}, 2000),

		adminQuestionniareSave: function () {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			this.autoSaveValues()

			if ( this.currentSection ) {
				Promise.resolve().then(() => {
					this.setUnfinishedQuestions(this.currentSection.value);
				});
			}
		},
		
		handleSubmitReview: function () {
      		window.scrollTo({ top: 0, behavior: 'smooth' })
			this.confirmDialog = true
      		if (this.moduleKey === 'entity-maintenance-program-resolutions') this.saveValues(true)
			this.validatingSubmission = true
		},

		navigateToSection: function (section) {
			this.handleTabChange(section)
			this.confirmDialog = false
		},

		calculateCompletedSections () {
			const { sections } = this

			// console.log(sections)

			const completedSections = Object.keys(sections).filter((thisSectionKey) => {
				const thisSection = sections[thisSectionKey]

				return !thisSection.unfinished || thisSection.unfinished.length === 0 && thisSection.visible
			})

			const completedSectionsPercent = completedSections.length / this.visibleTabs.length * 100

			this.completedSections = completedSections
			this.completedSectionsPercent = completedSectionsPercent
		},

		setUnfinishedQuestions: function (section) {
			const sections = this.sections
			const thisSection = sections[section]
			const { store } = thisSection
			thisSection.unfinished = store.getUnfinishedQuestions({
				values: this.questionnaire_values
			})

			this.calculateCompletedSections()
		},

		getHeaders: function () {
			return { authentication: Cookie.get('token'), 'Content-Type': 'application/json' }
		},

		exportData: async function () {
			try {
				// console.log('moduleId: '+this.moduleId, 'moduleKey: '+this.moduleKey, 'projectId: '+this.projectId)
				const export_data_rs = await axios.post(`${appUrls.api}/api/export_data`, {
					headers: this.getHeaders(),
					userId: this.isAdmin ? this.userId : Cookie.get('id'),
					moduleKey: this.moduleKey,
					projectId: this.projectId,
					su: this.isAdmin ? true : sessionStorage.sugar
				})
				
				console.log(export_data_rs.data.message)
	
			} catch ( error ) {
				console.log(error)
			}
		},

		isComplete: function () {
			const sections = this.sections
			const complete = Object.keys(sections).every((thisSectionKey) => {
				const section = sections[thisSectionKey]
				const { unfinished = [], visible } = section
				const unfinishedRequired = unfinished.filter((thisUnfinished) => thisUnfinished.props && thisUnfinished.props.required)

				return unfinishedRequired.length === 0 || !visible
			})

			return complete
		},

		autoSaveValues: async function () {
			try {
				this.isAutoSaving = true
				const complete = this.isComplete()

				const auto_saved = await axios.post(`${appUrls.api}/api/save_form_data`, {
					headers: this.getHeaders(),
					data: Object.entries(
						Object.assign(
							{},
							{
							complete
							},
							this.questionnaire_values
						)
					),
					section: this.currentSectionValue,
					progress: {
						finished: this.completedSections.length,
						total: this.visibleTabs.length,
						ready: complete
					},
					userId: this.isAdmin ? this.userId : Cookie.get('id'),
					moduleId: this.moduleId,
					moduleKey: this.moduleKey,
					projectId: this.projectId,
					su: this.isAdmin ? true : sessionStorage.sugar,
					parentProjectId: this.parentProjectId,
				})

				if (auto_saved.data.outcome) {
					// SUCCESS DIALOG W/ MESSAGE
					// console.log(auto_saved.data.message)
					// if ( ['completed', 'review'].includes(auto_saved.data.project_status) ) {
					//     axios.post(`${appUrls.api}/api/hubspot_flow`, {
					//         headers: this.getHeaders(),
					//         moduleId: this.moduleId,
					//         userId: Cookie.get('id')
					//     })
					//     .then( auto_saved => {
					//         if(auto_saved.data.outcome){
					//             console.log(auto_saved.data.message)
					//         }
					//     })
					//     .catch(function (error) {
					//         console.log(error);
					//     });
					// }

					setTimeout(() => {
						this.last_saved = new Date(auto_saved.data.date_saved).toLocaleString('en-US') // , { timeZone: 'UTC' }
						// this.checkCanSubmit();
						this.getCurrentProject()
						this.isAutoSaving = false
					}, 3500)
				} else {
					// FAILED DIALOG W/ MESSAGE
					this.isAutoSaving = false
				}
			} catch (err) {
				console.log(err)
			}
		},

		saveValues: function (submit) {
			const isSubmit = submit !== undefined

			if (isSubmit) {
				this.confirmDialog = false
			}

			const complete = this.isComplete()

			axios.post(`${appUrls.api}/api/save_form_data`, {
				headers: this.getHeaders(),
				data: Object.entries(
					Object.assign(
						{},
						{
							complete
						},
						this.questionnaire_values
					)
				),
				progress: {
					finished: this.completedSections.length,
					total: this.visibleTabs.length,
					ready: complete
				},
				section: this.currentSectionValue,
				userId: this.isAdmin ? this.userId : Cookie.get('id'),
				moduleId: this.moduleId,
				moduleKey: this.moduleKey,
				projectId: this.projectId,
				review: submit,
				su: this.isAdmin ? true : sessionStorage.sugar,
				parentProjectId: this.parentProjectId,
				resolutionData: this.resolutionData,
				resolutionSave: true
			})
			.then(res => {
				// console.log(res.data)
				if (res.data.outcome) {
					// SUCCESS DIALOG W/ MESSAGE
					if (res.data.project_status !== 'open') {
						if ( this.sendEmailOnSubmit ) this.exportData()

						if (this.moduleKey === 'entity-maintenance-program-resolutions') {
							this.$router.push(`/module_roadmap/entity-maintenance-program/${this.parentProjectId}`)
							return
						}
						
						this.$router.push(`/submitted_questionnaire/${this.moduleKey}/${this.projectId}`)
					} else {
						this.last_saved = new Date(res.data.date_saved).toLocaleString('en-US') // , { timeZone: 'UTC' }
						// this.checkCanSubmit();
						this.getCurrentProject()

						this.feedback_type = 'accent'
						this.feedback_msg = res.data.message
						this.saveDialog = true
						this.closeFeedbackDialog(res.data.status)
					}
				} else {
					// FAILED DIALOG W/ MESSAGE
					this.feedback_type = 'warning'
					this.feedback_msg = res.data.message
					this.saveDialog = true
					this.closeFeedbackDialog(res.data.status)
				}
			})
			.catch(function (error) {
				console.log(error)
			})
		},

		getDirectionalNavData () {
			const nav_tabs = []

			const thisTab = this.currentSection
			const index = this.visibleTabs.indexOf(thisTab)
			const previousSection = this.visibleTabs[index - 1]
			const nextSection = this.visibleTabs[index + 1]
			const current = {
				title: '',
				value: thisTab.value,
				color: 'grey--text'
			}

			if (previousSection) {
				nav_tabs.push({
					title: 'PREV SECTION',
					value: previousSection.value,
					color: 'primary--text'
				})
			}

			nav_tabs.push(current)

			if (nextSection) {
				nav_tabs.push({
					title: 'NEXT SECTION',
					value: nextSection.value,
					color: 'primary--text'
				})
			} else {
				if (this.moduleKey !== 'buyer' && this.checkReadOnly) {
					nav_tabs.push(current)
				} else {
					nav_tabs.push({
						title: this.moduleKey === 'buyer' ? 'UPDATE PROFILE' : this.saveButtonText,
						value: '',
						color: 'primary--text'
					})
				}
			}
			this.nav_tabs = nav_tabs
		},

		beginQuestionnaire: function () {
			axios.put(`${appUrls.api}/api/update_intro/${this.projectId}`, {
				headers: this.getHeaders()
			})
			.then(res => {
				// this.intro_visible = 'd-none'; // THESE ARE NOT USED UNTIL LATER - CHANGES ARE IN PROPS, NOT HERE
				// this.questionnaire_visible = 'd-block'; // THESE ARE NOT USED UNTIL LATER - CHANGES ARE IN PROPS, NOT HERE
			})
			.catch(function (error) {
				console.log(error)
			})
		},

		fetchQuestionnaireData: async function (module) {
			const res = await axios.get(`${appUrls.api}/api/module_structure/${this.moduleKey}/${module}`, {
				headers: this.getHeaders()
			})

			const { data = {} } = res
			const { outcome, structure } = data

			if (outcome) {
				return structure
			}
		},

		getQuestionnaireData: function (module) {
			return Promise.resolve(this.sections[module].structure)
		},

		getModuleIntro: function () {
			axios.get(`${appUrls.api}/api/module_info/${this.moduleKey}`, {
				headers: this.getHeaders()
			})
			.then(res => {
				// console.log(res.data.info)
				this.questionnaire_intro = res.data.info
			})
			.catch(function (error) {
				console.log(error)
			})
		},

		// item is the object to set visibility on
		// structure is the object to check dependencies on
		// for a question, item and structure are the same
		// for a section, item is the section, structure is the questionnaire
		watchDependencies: function (item, structure = item) {
			const self = this
			const { dependencies } = structure

			function setVisibility () {
				const isVisible = checkVisibility({
					item: structure,
					model: self.questionnaire_values
				})

				item.visible = isVisible
			}

			function watchItem(dep) {
				const { items, name } = dep;

				if (items) {
					// Recursively watch nested dependencies
					items.forEach(watchItem);
				}

				setVisibility();
				self.$watch(() => self.questionnaire_values[name], setVisibility);
			}

			if (dependencies) {
				dependencies.items.forEach(thisDep => watchItem(thisDep));
			} else {
				item.visible = true
			}
		},

		getSectionDataByTab: async function (tab, index) {
			const self = this
			const { value } = tab

			// Fetch all the section data
			const structure = await self.fetchQuestionnaireData(value)
			const store = new Store({
				structure,
				values: self.questionnaire_values
			})
			const map = store.getMap()

			for (const key in map) {
				const thisItem = map[key];

				self.watchDependencies(thisItem);
			}

			const sectionData = {
				index,
				structure,
				map,
				required: store.getRequired(),
				store,
				...tab
			}

			// Cache the section data and index on the sections data object
			self.sections[value] = sectionData

			return sectionData;
		},

		getQuestionnaireMenu: async function () {
			const self = this
			const res = await axios.get(`${appUrls.api}/api/questionnaire_menu/${this.moduleKey}/${this.projectId}`, {
				headers: this.getHeaders()
			})

			const { tabs } = res.data
			const dataPromises = tabs.map(this.getSectionDataByTab)

			// Wait to display menu until all sections have been fetched
			const sectionData = await Promise.all(dataPromises)

			self.tabs = sectionData.map((thisSectionData) => {
				const { index, title, value, structure } = thisSectionData

				self.watchDependencies(thisSectionData, structure)

				return {
					index,
					section: thisSectionData,
					title,
					value
				}
			})

			self.selectTabByIndex(0)

			return sectionData
		},

		gatherData: async function () {
			const dataObj = {}
			const res = await axios.get(`${appUrls.api}/api/user_data/${this.projectId}`, {
				headers: this.getHeaders()
			})

			for (const { section, question, value_type, answer, date_saved } of res.data.values) {
				const key = `${section}_${question}`
				this.last_saved = new Date(date_saved).toLocaleString('en-US')

				if (value_type === 'object' && answer != '') {
					dataObj[key] = JSON.parse(answer)
				} else {
					dataObj[key] = answer
				}
			}

			this.questionnaire_values = Object.assign(
				{},
				this.questionnaire_values,
				dataObj
			)
		},

		getUserInfo: async function () {
			const { data: userInfo } = await axios.get(`${appUrls.api}/api/account/${Cookie.get('id')}`, {
				headers: this.getHeaders()
			});

			// Save the user info to the questionnaire store for use in other components (checkVisibility)
			questionnaireStore.userInfo = userInfo.contact;
		},

		closeFeedbackDialog: function () {
			setTimeout(() => {
				this.saveDialog = false
			}, 3500)
		},

		handleTabChange: async function (tabName) {
			const self = this;
			this.questionnaire_data = {}

			// Set the current tab to active
			this.tabs.forEach((thisTab) => {
				thisTab.active = thisTab.value === tabName

				if (thisTab.active) {
					self.currentSection = thisTab;
				}
			});

			// When a tab is changed we will fetch the questionnaire data for the requested form
			const questionnaireData = await this.getQuestionnaireData(tabName)

			this.questionnaire_data = questionnaireData
			this.getDirectionalNavData()
		},

		selectTabByIndex: function (index) {
			const section = this.tabs[index].value

			if (section) {
				this.handleTabChange(section)
			}
		}
	},
	
	created: function () {
		this.isAdmin = ['admin', '8081'].some(el => window.location.origin.includes(el))
	},
	
	mounted: async function () {

		setTimeout( () => {
			this.show_extraWaiting = true
		}, 10000)

		// gather data before getting the questionnaire menu
		await Promise.all([
			this.getModuleIntro(),
			this.gatherData(),
			this.getUserInfo()
		]);
		await this.getQuestionnaireMenu()
		this.isPartner = this.questionnaireUserGroupIDs && this.questionnaireUserGroupIDs.includes(8)

		Object.keys(this.sections).forEach(this.setUnfinishedQuestions)
	}
}
</script>

<style scoped>
	.act_tb{
		font-weight: bold;
		/* background-color: #CCEAED; */
	}
	.bottom_border {
		border-top: 2px solid #EFEFEF;
	}
	.waiting_text {
		font-family: 'SansationLight';
		font-size: 1rem !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/questionnaire_template/questionnaire.vue